/**
 * Pure converters from the in-memory invoice-creation state to the shapes CreateInvoiceMutation
 * expects.
 *
 * A leaf module with no imports, deliberately. These were defined alongside the modal component,
 * which drags in generic_modal -> the action menu -> the design system, so anything that only wanted
 * a converter had to load the whole modal tree — and could not be unit tested at all in jsdom.
 * create_invoice_modal_v2.js re-exports both, so existing import sites keep working unchanged.
 */

export const invoiceLineConverter = ({
	id,
	description,
	quantity,
	unitPrice,
	discount,
	tax,
	projectId,
	timeRegIds,
	expenseItemIds,
	periodIds,
	deliverableAmounts,
	quantityLockedReason,
}) => ({
	id,
	name: '',
	projectId,
	quantity: +quantity,
	quantityText: quantity,
	unitPrice: +unitPrice,
	discount: +discount,
	tax: +tax,
	description,
	timeRegIds,
	expenseItemIds,
	periodIds,
	// deliverableIds is deliberately not forwarded. It stays on the in-memory line, where the
	// deliverables checklist uses it to track selection and the entries grid uses it to keep
	// deliverable lines across line regeneration — but the backend refuses a request carrying both
	// it and deliverableAmounts, and only the amounts describe what is actually being billed.
	deliverableAmounts,
	quantityLockedReason,
});

/**
 * Maps an in-memory work-detail row to the mutation's InvoiceWorkDetailRowInput.
 *
 * Note what is NOT here: no timeRegIds, no expenseItemIds, no periodIds, no unit price, no amount.
 * A work-detail row is an aggregate that states what was done; it never charges for it, and it
 * carries nothing that could mark a time registration as invoiced. Contrast invoiceLineConverter
 * above, which is the priced path.
 *
 * `key` and `sortOrder` are dropped on purpose: the server numbers rows by their position in the
 * list it receives.
 */
export const workDetailRowConverter = ({groupLabel, minutes, firstDate, lastDate, rate, value, removed}) => ({
	groupLabel,
	minutes,
	firstDate,
	lastDate,
	rate,
	value,
	removed: !!removed,
});
